import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <rect
        width="16"
        height="16"
        fill="url(#paint0_linear_423_418)"
        rx="6"
      ></rect>
      <path
        fill="url(#paint1_linear_423_418)"
        d="M12.842 4.092l-2.684 1.633-1.633-1.692c-.117-.116-.35-.175-.525-.175-.175 0-.408.059-.525.175L5.842 5.725 3.158 4.092c-.466-.292-1.108.116-.991.641l1.925 7c.058.234.35.409.641.409h6.534c.291 0 .583-.175.641-.409l1.925-7c.117-.525-.525-.933-.991-.641zm-3.092 5.95h-3.5a.46.46 0 01-.467-.467c0-.292.175-.467.467-.467h3.5a.46.46 0 01.467.467.46.46 0 01-.467.467z"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_423_418"
          x1="0"
          x2="16.123"
          y1="0"
          y2="0.125"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1D1F21"></stop>
          <stop offset="1" stopColor="#171413"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_423_418"
          x1="12.078"
          x2="-0.466"
          y1="12.142"
          y2="8.737"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F3C073"></stop>
          <stop offset="1" stopColor="#FFE3CA"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
}

export default Icon;
